import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../../../services/auth-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'report-message-modal',
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report-modal.component.scss'],
})
export class ReportChatMessageModalComponent {
  public messageToBeReportedId: string;
  public personToBeReportedOn: string;

  public close() {
    this.modalService.dismissAll(); //since this is only used for chat rn
  }
  isHovered = false;
  blockUser: boolean = false;
  remark: string = '';

  submitReport() {
    if (this.blockUser) {
      this.auth.block_user(this.personToBeReportedOn).subscribe((data) => {
        this.toastr.show('User is blocked');
      });
    }
    this.auth
      .report_chat_message(this.messageToBeReportedId, this.remark)
      .subscribe({
        next: (data) => {
          this.toastr.show('Message reported');
        },
        error: (err) => {
          console.error(err);

          this.toastr.error('Something went wrong when reporting message');
        },
      });
    this.close();
  }

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService
  ) {}
}
